import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('sac_token'));

  const checkAuth = useCallback(async () => {
    const savedToken = localStorage.getItem('sac_token');
    if (!savedToken) {
      setLoading(false);
      return;
    }
    try {
      const resp = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${savedToken}` },
        withCredentials: true
      });
      setUser(resp.data);
    } catch {
      localStorage.removeItem('sac_token');
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = (userData, authToken) => {
    setUser(userData);
    if (authToken) {
      setToken(authToken);
      localStorage.setItem('sac_token', authToken);
    }
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true, headers: token ? { Authorization: `Bearer ${token}` } : {} });
    } catch {}
    localStorage.removeItem('sac_token');
    setToken(null);
    setUser(null);
  };

  const getHeaders = () => {
    const t = token || localStorage.getItem('sac_token');
    return t ? { Authorization: `Bearer ${t}` } : {};
  };

  return (
    <AuthContext.Provider value={{ user, loading, token, login, logout, getHeaders, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
